<template>
  <transition mode="out-in" appear @enter="enter" @leave="leave" :css="false">
    <section class="coming">
      <div class="coming__bg">
        <div class="coming__bg-view">
          <video
            id="enterVideo"
            src="https://vod.plaync.com/LineageW/04_comingsoon_f_0810.mp4"
            muted
            playsinline
          />
          <video
            id="loopVideo"
            src="https://vod.plaync.com/LineageW/04_comingsoon_loop_f_0810.mp4"
            muted
            playsinline
            loop
            style="opacity: 0"
          />
          <div class="coming__bg-img"></div>
        </div>
      </div>
      <FrameBook></FrameBook>
      <div class="coming__contents">
        <div class="coming__txt">
          <div class="coming__txt-bg"></div>
          <div class="coming__txt-bl">
            <span class="bl--1"></span><span class="bl--2"></span
            ><span class="bl--3"></span>
            <hr class="bl--r" />
            <hr class="bl--l" />
          </div>
          <div class="coming__txt-tit"></div>
          <div class="coming__txt-desc"></div>
          <div class="coming__txt-desc2"></div>
        </div>
      </div>
      <ScrollBtn></ScrollBtn>
    </section>
  </transition>
</template>

<script>
import BaseSection from "./mixins/BaseSection.js";
import gsap from "gsap";
import FrameBook from "@/components/FrameBook";
import ScrollBtn from "../components/ScrollBtn";

export default {
  name: "coming",
  components: { FrameBook, ScrollBtn },
  mixins: [BaseSection],
  data() {
    return {
      name: "coming",
      bg: null,
      titMotion: null,
    };
  },
  methods: {
    setMotion() {
      const startTime = this.currentPage == "index" ? 0.5 : 0.5;
      this.enterMotion = new gsap.timeline({
        paused: true,
        onStart: () => {
          this.setIsMovePage(true);
        },
      });
      this.enterMotion
        .addLabel("start")
        .from(this.$el, startTime, { opacity: 0, ease: "power2.easeOut" });

      this.titMotion = new gsap.timeline({ paused: true });
      this.titMotion
        .addLabel("title")
        //  .to(this.$el.querySelector(`.coming__bg-img`), 3,{ autoAlpha:1}, 'title')
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--1`),
          0.4,
          { autoAlpha: 0, rotation: 190 },
          { autoAlpha: 1, rotation: 0, ease: "expo.easeInOut" },
          "title"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--2`),
          0.4,
          { autoAlpha: 0, rotation: -190 },
          { autoAlpha: 1, rotation: 0, ease: "expo.easeInOut" },
          "title"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--3`),
          0.4,
          { autoAlpha: 0, scale: 3 },
          { autoAlpha: 1, scale: 1, ease: "Back.easeOut" },
          "title"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--r`),
          0.4,
          { autoAlpha: 0, x: -30, y: -5 },
          { autoAlpha: 1, x: 0, y: 0, ease: "expo.easeInOut" },
          "title+=0.2"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--l`),
          0.4,
          { autoAlpha: 0, x: 30, y: -5 },
          { autoAlpha: 1, x: 0, y: 0, ease: "expo.easeInOut" },
          "title+=0.2"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt-bg`),
          0.4,
          { autoAlpha: 0, y: -10 },
          { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
          "title+=0.2"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt-tit`),
          0.4,
          { autoAlpha: 0, y: 30 },
          { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
          "title+=0.4"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt-desc`),
          0.4,
          { autoAlpha: 0, y: -30 },
          { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
          "title+=0.6"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt-desc2`),
          0.4,
          { autoAlpha: 0, y: 0 },
          { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
          "title+=0.7"
        )
        .fromTo(
          this.$el.querySelector(`.scroll-btn`),
          0.4,
          { autoAlpha: 0, y: 30 },
          { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
          "title+=0.8"
        );
    },
    leave(el, done) {
      gsap.to(this.$el, 0.5, { opacity: 0, onComplete: done });
    },
    enter(el, done) {
      this.setMotion();
      this.enterMotion.eventCallback("onComplete", () => {
        done();
      });
      if (this.currentPage == "index") this.autoPlay = false;
      this.setCurrentPage(this.name);
      this.setEnterPage(this);
    },
    start() {
      const video = document.querySelector("#enterVideo");

      video.addEventListener("ended", (event) => {
        const loopVideo = document.querySelector("#loopVideo");
        gsap.to(loopVideo, 0.2, {
          opacity: 1,
          onComplete: () => {
            video.remove();
            this.setIsMovePage(false);
          },
        });
        loopVideo.play();
      });
      video.play();

      this.enterMotion.play();
      setTimeout(() => {
        this.titMotion.play();
      }, 3000);
      //console.log( document.querySelector('#enterVideo'))
      // this.titMotion.play();
    },
  },
  mounted() {
    if (this.autoPlay) {
      this.start();
      this.setIsIntro(false);
    }
  },
};
</script>

<style lang="scss">
.coming {
  //@include bg($bg: '../assets/img/coming_guide.jpg');
  &__bg {
    @include position($width: 100%, $height: 100%);
    overflow: hidden;
    // visibility: hidden;
    &-view {
      @include position(
        $position: absolute,
        $top: 0,
        $left: 0,
        $width: 100%,
        $height: 100%
      );
      // @include bg($bg: '../assets/img/coming_bg.jpg', $cover: cover);
      video {
        min-width: 100%;
        min-height: 100%;
        width: auto;
        height: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    &-img {
      @include position(
        $position: absolute,
        $top: 0,
        $left: 0,
        $width: 100%,
        $height: 100%
      );
      //  @include bg($bg: '../assets/img/coming_bg.jpg', $cover:cover, $position:50% 50%);
      opacity: 0;
    }
  }
  &__contents {
    @include position($position: absolute, $top: 50%, $left: 50%);
    width: 100%;
    height: 100%;
    //  background: #f0f;
  }

  &__txt {
    @include position(
      $position: absolute,
      $width: 100%,
      $height: 923px,
      $top: 50%,
      $left: 50%
    );
    margin-top: -337px;
    &-bg {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 100%,
        $top: -160px,
        $left: 50%
      );
      @include bg($bg: "../assets/img/tit_bg2.png", $position: 50% 0);
    }
    &-bl {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 34px,
        $top: 157px,
        $left: 50%
      );
      > span {
        display: block;
        @include position(
          $position: absolute,
          $width: 34px,
          $height: 34px,
          $top: 0,
          $left: 50%
        );
        @include bg($bg: "../assets/img/tit_icon_b.png");
        &:nth-child(1) {
          background-position-x: 0;
        }
        &:nth-child(2) {
          background-position-x: -34px;
        }
        &:nth-child(3) {
          background-position-x: -68px;
        }
      }
      > hr {
        border: none;
        @include position(
          $position: absolute,
          $width: 96px,
          $height: 14px,
          $top: 2px,
          $left: 50%
        );
        @include bg($bg: "../assets/img/tit_icon_l.png");
        margin-left: 17px;
        &:last-child {
          @include bg($bg: "../assets/img/tit_icon_r.png");
          margin-left: -113px;
        }
      }
    }
    &-tit {
      @include position(
        $position: absolute,
        $width: 290px,
        $height: 55px,
        $top: 220px,
        $left: 50%
      );
      @include bg($bg: "../assets/img/coming_tit.png", $cover: cover);
      @include hide-text;
    }
    &-desc {
      @include position(
        $position: absolute,
        $width: 1181px,
        $height: 198px,
        $top: 260px,
        $left: 50%
      );
      @include bg($bg: "../assets/img/coming_desc_0917.png", $cover: cover);
      /*
      .en &,
      .ja &,
      .zh & {
        @include bg(
          $bg: "../assets/img/coming_desc_en_0917.png",
          $cover: cover
        );
      }*/
    }
    &-desc2 {
      @include position(
        $position: absolute,
        $width: 567px,
        $height: 99px,
        $top: 400px,
        $left: 50%
      );
      @include bg($bg: "../assets/img/coming_desc_en_2_0917.png", $cover: cover);
      //@include bg($bg: "../assets/img/coming_desc_en_2_0917", $cover: cover);
      .ko &{
        width: 212px;
        height: 106px;
        margin-left: -106px;
        @include bg($bg: "../assets/img/coming_desc_2_0917.png", $cover: cover);
        //@include bg($bg: "../assets/img/coming_desc_2_0917", $cover: cover);
      }
    }
  }

  @include bp(tablet) {
    //@include bg($bg: '../assets/img/coming_guide_m.jpg');
    // background-size: 100% auto;
    &__bg {
      min-height: auto;
      &-view {
        video {
          height: 100%;
        }
      }
    }
    &__txt {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 563px/2,
        $top: 50%,
        $left: 50%
      );
      margin-top: -218px;
      &-bg {
        @include position(
          $position: absolute,
          $width: 100%,
          $height: 100%,
          $top: -40px,
          $left: 50%
        );
        @include bg($bg: "../assets/img/tit_bg2.png", $position: 50% 0);
        background-size: 400px auto;
      }
      &-bl {
        top: 55px;
        transform: scale(0.5);
      }
      &-tit {
        @include position(
          $position: absolute,
          $width: 290px/2,
          $height: 55px/2,
          $top: 97px,
          $left: 50%
        );
        @include bg($bg: "../assets/img/coming_tit.png", $cover: cover);
        @include hide-text;
      }
      &-desc {
        width: 365px;
        height: 135px;
        margin-left: -182px;
        top:117px;
        @include bg(
            $bg: "../assets/img/coming_desc_0917_m.png",
            $cover: cover
          );
       
      }
      &-desc2 {
        @include position(
          $position: absolute,
          $width: 567px/2,
          $height: 99px/2,
          $top: 243px,
          $left: 50%
        );
        .ko &{
          width: 106px;
          height: 53px;
          margin-left: -53px;
        }
      }
    }
  }

  @media (max-width: 960px) and (min-aspect-ratio: 1920/1080) {
    &__bg {
      &-view {
        video {
          width: 100%;
          height: auto;
        }
      }
    }
  }
}
</style>
